import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { createId, downloadFile, getFileNameFromPath } from '@core/util/file';
import { BusinessBaseDocx, BusinessBaseDocxTypes } from '@models/businesses';
import { BaseDocxService } from '@services/base-docx/base-docx.service';
import { UploadService } from '@services/file/upload.service';
import { cloneDeep } from 'lodash';
import { take } from 'rxjs/operators';
import { DropdownOption } from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';
import { DropzoneComponent } from 'src/app/shared/atomic/atoms/dropzone/dropzone.component';
import { DRAWER_DATA } from 'src/app/ui/drawer/drawer-data.token';
import { DrawerService } from 'src/app/ui/drawer/drawer.service';

export interface BusinessBasedDocxDrawerData {
	baseDocx: BusinessBaseDocx;
}
@Component({
	selector: 'app-business-base-docx-drawer',
	templateUrl: './business-base-docx-drawer.component.html',
	standalone: false,
})
export class BusinessBaseDocxDrawerComponent implements OnInit {
	@ViewChild('fileUploadInput', { static: false })
	fileuploadInput: DropzoneComponent;

	@ViewChild('form') form: NgForm;
	public baseDocx: BusinessBaseDocx;
	public originalCopy: BusinessBaseDocx;

	public typesList: DropdownOption<BusinessBaseDocxTypes>[] = Object.values(
		BusinessBaseDocxTypes,
	).map((type) => ({ name: type, value: type }));

	public newFile: File;

	constructor(
		@Inject(DRAWER_DATA) { baseDocx }: BusinessBasedDocxDrawerData,
		private baseDocxService: BaseDocxService,
		private drawerService: DrawerService,
		private uploadService: UploadService,
	) {
		this.baseDocx = cloneDeep(baseDocx);
		this.originalCopy = cloneDeep(baseDocx);
	}

	ngOnInit(): void {
		this.drawerService.setPrimaryAction('Save', () => {
			this.save();
		});

		this.drawerService.setSecondaryAction('Cancel', () => {
			this.drawerService.closeDrawer();
		});
	}

	async save() {
		this.form.onSubmit(null);
		if (this.form.invalid || !this.baseDocx.path) {
			return;
		}
		let baseDocx = this.baseDocx;
		if (this.newFile) {
			//Enfores the id to be part of the baseDocx body
			const id = createId();
			this.baseDocx.id = id;
			baseDocx = await this.baseDocxService.addOverride(this.newFile, {
				...this.baseDocx,
			});
		} else if (this.baseDocx !== this.originalCopy) {
			this.baseDocxService.updateBaseDocx(baseDocx);
		}
		this.drawerService.closeDrawer();
	}

	triggerReUpload() {
		this.fileuploadInput.openFileUploadMenu();
	}

	async download(path: string) {
		await this.uploadService
			.get$(path)
			.pipe(take(1))
			.subscribe((res) => {
				downloadFile(getFileNameFromPath(path), res);
			});
	}

	async onFileChange(file: any) {
		this.newFile = file;
		this.baseDocx.path = `/${file.name}`;
	}
}
